import React from 'react'

const Forty_one = () => {
    return (
        <div className='container'>
            <h1>Bubble sort using Pointer</h1>
           <p>
            Bubble Sort in C is a simple sorting algorithm that repeatedly steps through the list to be sorted, compares each pair of adjacent items and swaps them if they are in the wrong order.
           </p> 
            <div className='containers'>
          <code className='library'>  #include</code>&lt;stdio.h&gt; <br/>
<br/>
<code className='keywords'>int </code> *a[100],i,j,item;<br/>
<br/>
<code className='keywords'>void</code> main()<br/>
<br/>
&#123; <br/>

<code className='library'> void</code> sort(),display();<code className='comment'> //function declarations</code> <br/>
<br/>
<code className='library'> int </code> i;<br/>
<br/>
   clrscr();<br/>
<br/>
<code className='library'> printf</code>("\n Enter the number of elements in the first array\n");<br/>
<br/>
<code className='library'>  scanf </code>("%d",&item); //reding elements from user<br/>
<br/>
<code className='library'>  printf</code>("\n Enter %d numbers\n",item);<br/>
<br/>
<code className='keywords'> for</code>(i=0;i&lt;item;++i)<br/>
<br/>
<code className='library'> scanf</code>("%d",&a[i]);<br/>
  <br/>
  <code className='function'>  sort</code>(); //calling sort function to perform bubble sort<br/>
<br/>
<code className='function'>  display</code>(); //calling display function to display elements<br/>
<br/>
&#125;<br/>
<br/>
<code className='keywords'>void </code> sort() <code className='comment'>//sort function to sort elements</code><br/>
<br/>
 &#123; <br/>
<br/>
<code className='keywords'>  int </code>swap=1,*temp;<br/>
<br/>
<code className='keywords'> for</code> (i=0;i&lt;item && swap==1;++i)<br/>
<br/>
   &#123; <br/>
<br/>
    swap=0;<br/>
<br/>
<code className='keywords'>  for </code>(j=0;j&lt;item-(i+1);++j)<br/>
<br/>
<code className='keywords'>  if</code> (a[j]&gt;a[j+1])<br/>
    &#123; <br/>
<br/>
     temp=a[j];<br/>
<br/>
    a[j]=a[j+1];<br/>
<br/>
    a[j+1]=temp;<br/>
<br/>
    swap=1;<br/>
   &#125;<br/>
<br/>
  &#125;<br/>
<br/>
 &#125;<br/>


 <code className='keywords'> void </code>display() //display function

 &#123; <br/>

 <code className='library'> printf</code>("\n Sorted elements are:\n");

 <code className='keywords'> for</code>(i=0;i&lt;item;++i)

 <code className='library'> printf</code>("%d\n",a[i]);

 <code className='function'> getch</code>();

 &#125;
            </div>
        </div>
    )
}

export default Forty_one
